import { createCommentAnchor, measureSectionRangeOffsets, sectionTextFromElement } from './comment-anchor-markup';
import type { CommentAnchor } from './types';

type Args = {
    readonly sectionRoot: HTMLElement;
    readonly range: Range;
};

type Failure = {
    readonly ok: false;
    readonly reason: 'collapsed' | 'cross-section' | 'empty';
};

type Success = {
    readonly ok: true;
    readonly anchor: CommentAnchor;
};

export type WrapSelectionResult = Success | Failure;

const isWithin = (root: HTMLElement, node: Node): boolean => root === node || root.contains(node);

export const wrapSelectionInMark = ({ sectionRoot, range }: Args): WrapSelectionResult => {
    if (range.collapsed) {
        return { ok: false, reason: 'collapsed' };
    }
    if (!isWithin(sectionRoot, range.startContainer) || !isWithin(sectionRoot, range.endContainer)) {
        return { ok: false, reason: 'cross-section' };
    }
    const { start: startChar, end: endChar } = measureSectionRangeOffsets(sectionRoot, range);
    const text = sectionTextFromElement(sectionRoot);
    if (endChar <= startChar || text.slice(startChar, endChar).trim().length === 0) {
        return { ok: false, reason: 'empty' };
    }

    return {
        ok: true,
        anchor: createCommentAnchor(text, startChar, endChar),
    };
};
